import { useEffect, useState } from "react";
import api, { mediaUrl } from "@/lib/api";
import { Reveal } from "./Reveal";
import { Clock, ArrowUpRight } from "lucide-react";
import { scrollTo } from "./Nav";

export default function Workshops() {
  const [workshops, setWorkshops] = useState([]);

  useEffect(() => {
    api.get("/workshops").then((r) => setWorkshops(r.data)).catch(() => {});
  }, []);

  if (!workshops.length) return null;

  return (
    <section id="ateliers" data-testid="workshops-section" className="py-20 md:py-28 bg-[#201815] rounded-t-[3rem]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-14 flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-[#D9822B] mb-4">Nos ateliers</p>
            <h2 className="font-display tracking-tight text-[#FBF8F3] text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Une formule pour
              <br />
              <span className="italic text-[#D9822B]">chaque envie.</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-[#FBF8F3]/60 leading-relaxed">
            Le prix de l'atelier varie en fonction de la pièce choisie : chaque pièce affichée comprend les peintures, les outils, l'émaillage et la cuisson.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {workshops.map((w, i) => (
            <Reveal key={w.id} delay={i * 0.1}>
              <article
                data-testid={`workshop-card-${i}`}
                className="group relative rounded-2xl overflow-hidden bg-[#2A201C] border border-white/5 h-full flex flex-col"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={mediaUrl(w.image_url)}
                    alt={w.name}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#2A201C] via-transparent to-transparent" />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-[#FBF8F3]/90 px-3 py-1.5 text-xs font-mono-brand text-[#201815]">
                    <Clock size={12} /> {w.duration}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-display text-2xl text-[#FBF8F3] mb-2">{w.name}</h3>
                  <p className="text-sm text-[#FBF8F3]/60 leading-relaxed flex-1">{w.description}</p>
                  <div className="mt-6 flex items-center justify-between">
                    <span className="font-mono-brand text-sm text-[#D9822B]">{w.price}</span>
                    {(w.price || "").toLowerCase().includes("devis") ? (
                      <button
                        data-testid={`workshop-quote-btn-${i}`}
                        onClick={() => scrollTo("#contact")}
                        className="inline-flex items-center gap-1.5 rounded-full border border-[#D9822B]/50 px-4 py-2 text-xs text-[#D9822B] transition-colors duration-300 hover:bg-[#D9822B] hover:text-[#201815]"
                      >
                        Demander un devis <ArrowUpRight size={13} />
                      </button>
                    ) : (
                      <button
                        data-testid={`workshop-book-btn-${i}`}
                        onClick={() => scrollTo("#reservation")}
                        className="inline-flex items-center gap-1.5 rounded-full border border-[#FBF8F3]/20 px-4 py-2 text-xs text-[#FBF8F3] transition-colors duration-300 hover:bg-[#C85A32] hover:border-[#C85A32]"
                      >
                        Réserver <ArrowUpRight size={13} />
                      </button>
                    )}
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
